var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsersIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_120_1624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3 10C9.40313 10 8.97187 10.5 7.5 10.5C6.02813 10.5 5.6 10 4.7 10C2.38125 10 0.5 11.8812 0.5 14.2V15C0.5 15.8281 1.17188 16.5 2 16.5H13C13.8281 16.5 14.5 15.8281 14.5 15V14.2C14.5 11.8812 12.6188 10 10.3 10ZM13 15H2V14.2C2 12.7125 3.2125 11.5 4.7 11.5C5.15625 11.5 5.89688 12 7.5 12C9.11563 12 9.84063 11.5 10.3 11.5C11.7875 11.5 13 12.7125 13 14.2V15ZM7.5 9.5C9.98438 9.5 12 7.48438 12 5C12 2.51562 9.98438 0.5 7.5 0.5C5.01562 0.5 3 2.51562 3 5C3 7.48438 5.01562 9.5 7.5 9.5ZM7.5 2C9.15313 2 10.5 3.34687 10.5 5C10.5 6.65313 9.15313 8 7.5 8C5.84687 8 4.5 6.65313 4.5 5C4.5 3.34687 5.84687 2 7.5 2Z",
    fill: "#8E93A5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_120_1624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/usersIcon.cafb2e17.svg";
export { ForwardRef as ReactComponent };